var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrmAppsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1378_5914)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.89209,
    y: 10.7031,
    width: 5.45872,
    height: 5.46306,
    rx: 0.5,
    stroke: "#4D4558"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.8335,
    y: 3.83301,
    width: 5.45881,
    height: 5.46174,
    rx: 0.5,
    stroke: "#4D4558"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.7075,
    y: 10.7031,
    width: 5.45915,
    height: 5.46306,
    rx: 0.5,
    stroke: "#4D4558"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.7075,
    y: 3.83301,
    width: 5.45915,
    height: 5.46174,
    rx: 0.5,
    stroke: "#4D4558"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1378_5914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 13.3333,
    fill: "white",
    transform: "translate(3.3335 3.33301)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmAppsIcon);
export default __webpack_public_path__ + "static/media/crm-apps-icon.6ba986f1a3fb157da9899571f506e8b6.svg";
export { ForwardRef as ReactComponent };